import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin, Youtube } from "lucide-react";
import { DOCTOR } from "@/data/static";

export default function Footer() {
  return (
    <footer className="bg-[#0A1B2E] text-slate-300 mt-24" data-testid="footer">
      <div className="container-x py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="font-heading text-white text-xl font-semibold">Aastha Maternity &amp; Ortho Care Centre</div>
          <p className="text-sm mt-3 text-slate-400 leading-relaxed">Led by {DOCTOR.name} — {DOCTOR.title}. Trusted orthopedic and maternity care in Sasaram, Bihar.</p>
          <div className="flex gap-3 mt-5">
            {[Facebook, Instagram, Linkedin, Youtube].map((Icon, i) => (
              <a key={i} href="#" aria-label="social" className="h-9 w-9 rounded-full bg-white/5 hover:bg-primary flex items-center justify-center transition-colors">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <div className="text-white font-heading font-medium mb-4">Quick Links</div>
          <ul className="space-y-2 text-sm">
            {["About","Treatments","Gallery","Blog","Contact","Appointment"].map(l=>(
              <li key={l}><Link to={`/${l.toLowerCase()==="about"?"about":l.toLowerCase()}`} className="hover:text-white">{l}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <div className="text-white font-heading font-medium mb-4">Treatments</div>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>Knee Replacement</li>
            <li>Hip Replacement</li>
            <li>Spine Surgery</li>
            <li>Sports Injury</li>
            <li>Arthroscopy</li>
            <li>Trauma Surgery</li>
          </ul>
        </div>
        <div>
          <div className="text-white font-heading font-medium mb-4">Get in Touch</div>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3"><MapPin className="w-4 h-4 mt-1 text-primary-light shrink-0"/> <span>{DOCTOR.address}</span></li>
            <li className="flex gap-3"><Phone className="w-4 h-4 mt-1 text-primary-light shrink-0"/> <a href={`tel:${DOCTOR.phoneRaw}`}>{DOCTOR.phone}</a></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 mt-1 text-primary-light shrink-0"/> <a href={`mailto:${DOCTOR.email}`}>{DOCTOR.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} {DOCTOR.name}. All rights reserved.</div>
          <div className="flex gap-5">
            <Link to="/admin/login" className="hover:text-white" data-testid="footer-admin-link">Admin</Link>
            <a href="#">Privacy</a>
            <a href="#">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
